import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {AccountsSetupGuideContainer} from '../../../../../../../../src/components/accounts/accountsSetupGuide/accountsSetupGuideContainer';
import {accountsLearnMoreLink} from '../../../../../../../../src/helpers/accountHelpers';
import {openInBrowser} from '../../../../../../../../srcCommon/browser/openInBrowser';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../../../shared/ui/src/theme/userThemeProvider';
import {InfoBox} from './infoBox';

/*
 * Props.
 */

interface AccountInfoBoxesProps {
  onSendFeedbackClick: Handler;
  onImportCSVClick: Handler;
  onImportSalesforceClick: Handler;
}

/*
 * Styles.
 */

const StyledInfoBoxWrapperDiv = styled.div`
  padding: 15px 53px 24px 0px;
  background: ${(p) => p.theme.greys.white};
  margin-left: -12px;

  display: flex;
  flex-direction: column;
  gap: 16px;
`;

/*
 * Component.
 */

export const AccountInfoBoxes: FC<AccountInfoBoxesProps> = ({
  onSendFeedbackClick,
  onImportCSVClick,
  onImportSalesforceClick,
}) => {
  const theme = useUserTheme();
  const onLearnMoreClick = () => openInBrowser(accountsLearnMoreLink);

  return (
    <StyledInfoBoxWrapperDiv>
      <AccountsSetupGuideContainer
        onImportCSVClick={onImportCSVClick}
        onImportSalesforceClick={onImportSalesforceClick}
      />

      <InfoBox
        title={<Trans id="account-infobox-title">What are Accounts?</Trans>}
        footer={<Trans id="account-infobox-learn-more-link">Learn more</Trans>}
        onFooterClick={onLearnMoreClick}
      >
        <Trans id="account-infobox-body">
          Accounts represent the companies or organizations you work with. Add accounts to see account
          information in the inbox, automatically route conversations to account owners, and more.
        </Trans>
      </InfoBox>

      <InfoBox
        iconName="thumbsup"
        backgroundColor={theme.palette.grey.shade10}
        title={<Trans id="account-infobox-feedback-title">What do you think?</Trans>}
        isExternalLink={false}
        footer={<Trans id="account-infobox-feedback-link">Send feedback</Trans>}
        onFooterClick={onSendFeedbackClick}
      >
        <Trans id="account-infobox-feedback-body">
          Help us improve this feature by sharing feedback with our product team.
        </Trans>
      </InfoBox>
    </StyledInfoBoxWrapperDiv>
  );
};
